<template>
  <svg
    width="42"
    height="75"
    viewBox="0 0 42 75"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g opacity="0.2">
      <path
        d="M32.4826 68.1605C32.4921 65.2878 27.1822 62.9413 20.6227 62.9195C14.0632 62.8977 8.7379 65.2089 8.7284 68.0816C8.71889 70.9543 14.0287 73.3008 20.5883 73.3226C27.1478 73.3444 32.4731 71.0333 32.4826 68.1605Z"
        fill="white"
        stroke="black"
        stroke-width="1.72"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <path
      d="M34.4439 15.4048C26.7609 12.0407 14.343 12.0219 6.707 15.3671C2.19312 17.346 0.364059 20.0504 1.20571 22.6323L8.74765 68.1414C8.71944 66.7986 9.86672 65.4558 12.1989 64.4334C16.8256 62.4074 24.3441 62.4168 28.999 64.4569C31.3171 65.4746 32.4879 66.7986 32.502 68.1272L40.0392 22.7454C40.8903 20.1493 39.0283 17.4072 34.4533 15.4048H34.4439Z"
      fill="white"
      stroke="#72A231"
      stroke-width="1.72"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M32.4826 68.1605C32.4921 65.2878 27.1822 62.9413 20.6227 62.9195C14.0632 62.8977 8.7379 65.2089 8.7284 68.0816C8.71889 70.9543 14.0287 73.3008 20.5883 73.3226C27.1478 73.3444 32.4731 71.0333 32.4826 68.1605Z"
      fill="white"
      stroke="#72A231"
      stroke-width="1.72"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M36.0002 35.0568C36.0002 35.0568 35.9532 35.3206 35.8733 35.8012C35.8733 35.8012 35.8733 35.8012 35.8733 35.7965L35.9955 35.0568H36.0002Z"
      fill="white"
      stroke="black"
      stroke-width="1.72"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M4.99549 33.6056C5.38576 35.0709 7.1913 36.4891 9.76328 37.6152C15.7959 40.2584 25.5478 40.2725 31.5428 37.6434C34.0348 36.5503 35.8027 35.1746 36.2165 33.7517C36.5551 31.7163 37.218 27.7303 37.6506 25.1201C38.4405 22.8256 36.809 20.3991 32.7606 18.6228C26.0133 15.664 15.1047 15.6498 8.39971 18.5899C4.46417 20.3143 2.85138 22.6748 3.55668 24.9269C4.16323 28.5784 5.00019 33.6009 5.00019 33.6009"
      fill="white"
    />
    <path
      d="M4.99549 33.6056C5.38576 35.0709 7.1913 36.4891 9.76328 37.6152C15.7959 40.2584 25.5478 40.2725 31.5428 37.6434C34.0348 36.5503 35.8027 35.1746 36.2165 33.7517C36.5551 31.7163 37.218 27.7303 37.6506 25.1201C38.4405 22.8256 36.809 20.3991 32.7606 18.6228C26.0133 15.664 15.1047 15.6498 8.39971 18.5899C4.46417 20.3143 2.85138 22.6748 3.55668 24.9269C4.16323 28.5784 5.00019 33.6009 5.00019 33.6009"
      stroke="#72A231"
      stroke-width="1.72"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M36.2117 33.7564C35.8027 35.1793 34.03 36.5551 31.538 37.6482C25.543 40.2725 15.7911 40.2631 9.7585 37.6199C7.18653 36.4938 5.38099 35.0709 4.99072 33.6104L6.10979 40.3479L9.94189 63.4204C10.13 64.6172 11.0139 65.7951 13.0875 66.7044C17.2722 68.5372 24.029 68.5466 28.1855 66.7233C30.2685 65.8092 30.922 64.6549 31.2888 63.4063C31.2888 63.4063 33.7338 48.6638 35.1021 40.4421C35.4453 38.3643 36.0613 34.661 36.2117 33.7564Z"
      fill="white"
      stroke="#72A231"
      stroke-width="1.72"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M34.4439 15.4048C26.7609 12.0407 14.343 12.0219 6.70704 15.3671C-0.92895 18.7123 -0.891338 24.1542 6.79167 27.5182C14.4747 30.8823 26.8926 30.9011 34.5286 27.5559C42.1645 24.2107 42.1269 18.7689 34.4439 15.4048ZM33.1227 26.9387C26.2578 29.9447 15.0953 29.9306 8.18815 26.9057C1.28097 23.8809 1.24806 18.9903 8.10823 15.9843C14.9731 12.9783 26.1355 12.9925 33.0427 16.0173C39.9499 19.0421 39.9828 23.9327 33.1227 26.9387Z"
      fill="white"
      stroke="black"
      stroke-width="1.72"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M6.79156 27.5183C14.4746 30.8823 26.8925 30.9012 34.5284 27.556C35.4782 27.1414 36.3058 26.6891 37.0158 26.2179C37.6693 25.3227 37.9374 24.3898 37.8198 23.4616V23.4334C35.7086 11.3717 14.5686 7.66846 14.5686 7.66846C14.5686 7.66846 14.8037 11.2163 14.752 11.8523C14.3711 16.4697 13.5718 15.5462 8.85102 18.2742C8.37612 18.5475 7.88243 18.8066 7.38872 19.061C3.66947 20.9833 2.46576 23.5182 3.78701 25.8268C4.60516 26.4299 5.60667 26.9953 6.79156 27.5136V27.5183Z"
      fill="white"
      stroke="#72A231"
      stroke-width="1.72"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M6.79153 27.5183C9.92304 28.8893 13.8398 29.7044 17.8976 29.9636C19.6373 27.7774 22.6654 23.2637 22.5055 18.5569C22.2845 12.0596 14.5733 7.67316 14.5733 7.67316C14.5733 7.67316 19.0542 13.2988 15.4196 18.4061C12.4762 22.5476 5.63955 24.9929 4.70386 26.4346C5.32452 26.8115 6.01571 27.1743 6.79153 27.5183Z"
      fill="white"
      stroke="#72A231"
      stroke-width="1.72"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M26.2531 19.6217C26.9067 23.9516 26.2484 27.7821 25.7688 29.7704C28.5618 29.4453 31.2137 28.8469 33.5129 27.9753C33.9267 25.6525 32.7841 20.7996 30.4284 16.5403C27.0665 10.4577 14.5781 7.67786 14.5781 7.67786C14.5781 7.67786 25.0071 11.3529 26.2578 19.6217H26.2531Z"
      fill="white"
      stroke="#72A231"
      stroke-width="1.72"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M34.444 15.4048C33.4566 14.9714 32.3845 14.5945 31.2607 14.2741C32.1776 14.9243 33.0475 15.6263 33.8327 16.3896C39.9406 19.4332 39.7149 24.0553 33.1227 26.9435C26.2579 29.9495 15.0954 29.9353 8.18821 26.9105C1.28103 23.8857 1.24812 18.9951 8.10829 15.9891C9.94675 15.1834 12.1003 14.5945 14.3948 14.2222C14.4747 13.949 14.5359 13.6333 14.5923 13.2705C11.7053 13.671 8.98754 14.3683 6.70239 15.3672C-0.933596 18.7124 -0.89597 24.1542 6.78704 27.5183C14.47 30.8823 26.8879 30.9012 34.5239 27.556C42.1599 24.2108 42.1223 18.7689 34.4393 15.4048H34.444Z"
      fill="white"
      stroke="#72A231"
      stroke-width="1.72"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M4.93429 1.91562C4.4829 2.30197 3.57071 2.52812 2.89833 2.42447C2.22595 2.32082 2.05198 1.92033 2.50337 1.53398C2.95476 1.14764 3.86695 0.92148 4.53933 1.02513C5.21171 1.12879 5.38568 1.52927 4.93429 1.91562Z"
      fill="white"
      stroke="#72A231"
      stroke-width="1.72"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M14.5592 23.3391C14.5075 23.1601 5.1506 1.34082 5.1506 1.34082C5.23524 1.50573 5.17411 1.71303 4.93901 1.91092C4.48762 2.29727 3.57545 2.52342 2.90307 2.41977C2.56923 2.36794 2.35764 2.24073 2.28711 2.08054C2.35764 2.24544 11.597 23.8668 11.6769 24.0317C11.7569 24.1872 11.9637 24.305 12.2882 24.3568C12.9606 24.4605 13.868 24.2343 14.3241 23.848C14.531 23.6689 14.6062 23.4899 14.5639 23.3391H14.5592Z"
      fill="white"
      stroke="#72A231"
      stroke-width="1.72"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
